module.exports = __webpack_public_path__ + "img/caja_asignar.c4ba48d2.png";